import React from "react"
import {manualCompletePending} from "../../resources/application"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {CompletePendingTarget} from "../ApplicationCompletePendingButton/CompletePendingButton"
import {CompletePendingModal as CompletePendingActionModal} from "./ApplicationCompletePending"

interface CompletePendingActionModalProps {
	application: CompletePendingTarget
	close: () => void
	onSuccess: () => void
}

export function CompletePendingModal({application, close, onSuccess}: CompletePendingActionModalProps) {
	const accessToken = useAccessToken()
	const [state, completePending] = useAsyncResultIdle(manualCompletePending)

	return (
		<CompletePendingActionModal
			title="Complete Pending Application"
			close={close}
			onSuccess={onSuccess}
			state={state}
			completePendingFn={() => completePending(accessToken, application)}
		/>
	)
}
